import { IconSvg, IconSvgProps } from "./icon"

export default function PlayFill(props: IconSvgProps) {
  return (
    <IconSvg {...props} fill="currentColor" strokeWidth={0}>
      <path d="M4.928 18.879a1.466 1.466 0 0 0 .81 1.285 1.594 1.594 0 0 0 1.569 0l11.121-6.878a1.427 1.427 0 0 0 0-2.572L7.307 3.887a1.594 1.594 0 0 0-1.569 0 1.466 1.466 0 0 0-.81 1.286v13.706Z" />
    </IconSvg>
  )
}
